import { Outlet } from 'react-router-dom';
import { Box } from 'src/components/ui';
import { shouldShowPublicWebsite } from 'src/lib/utils/subdomain';

import Header from './Header';

const PublicLayout = () => {
	// Don't show header/padding for public website subdomains (*.website.fusionads.ai)
	const isPublicWebsite = shouldShowPublicWebsite();

	if (isPublicWebsite) {
		return <Outlet />;
	}

	return (
		<Box w="100%">
			<Header />
			<Box
				minH="calc(100vh - 71px)"
				pt={{ base: '20px', md: '52px' }}
				pb={{ base: '50px', md: '100px' }}
				px={10}
			>
				<Outlet />
			</Box>
		</Box>
	);
};

export default PublicLayout;
